import React from 'react'
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image'

interface PlaatjieProps extends GatsbyImageProps {
  image: any
  className?: string
}

const Plaatjie: React.FC<PlaatjieProps> = ({ image, className = '', ...rest }) => {
  if (!image) {
    return null
  }

  if (image?.url) {
    if (image.subtype === 'svg+xml') {
      return <img src={image.url} className={className} {...rest} />
    }

    return (
      <div className={`gatsby-image-wrapper ${className}`}>
        <picture>
          <img src={image.url} {...rest} />
        </picture>
      </div>
    )
  }

  if (image?.localFile?.childSvg?.content) {
    return (
      <div
        className={`gatsby-image-wrapper gatsby-image-wrapper-inline-svg ${className}`}
        dangerouslySetInnerHTML={{ __html: image.localFile.childSvg.content.data }}
      />
    )
  }

  if (image?.localFile?.publicURL) {
    return <img src={image?.localFile?.publicURL} className={className} {...rest} />
  }

  if (!image?.localFile?.childImageSharp?.gatsbyImageData) {
    return null
  }

  return (
    <GatsbyImage
      image={image?.localFile?.childImageSharp?.gatsbyImageData}
      className={className}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  )
}

export default Plaatjie
